import React from 'react';
import { connect } from 'react-redux';
import { intlShape, injectIntl } from 'react-intl';

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import { EditIcon, DuplicateIcon, TrashIcon } from '../../../../images/icons/WrapSvg';

class PopupItem extends React.Component {
    render() {
        const { open, intl, duplicateOnly } = this.props;
        return (
            <Menu anchorEl={open} open={Boolean(open)} onClose={this.props.onClick('close')}>
                {!duplicateOnly &&
                    <MenuItem className={'bg_ice_blue'} onClick={this.props.onClick('edit')}>
                        <ListItemIcon className={'icon c_bluish'}>
                            <EditIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText
                            classes={{ primary: 'barlow_semibold_label c_bluish' }}
                            inset
                            primary={intl.formatMessage({ id: 'popup_edit_menuitem' })}
                        />
                    </MenuItem>
                }
                {duplicateOnly &&
                    <MenuItem className={'bg_ice_blue'} onClick={this.props.onClick('see')}>
                        <ListItemIcon className={'icon c_bluish'}>
                            <EditIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText
                            classes={{ primary: 'barlow_semibold_label c_bluish' }}
                            inset
                            primary={intl.formatMessage({ id: 'popup_partial_edit_menuitem' })}
                        />
                    </MenuItem>
                }
                <MenuItem className={'bg_ice_blue'} onClick={this.props.onClick('duplicity')}>
                    <ListItemIcon className={'icon c_bluish'}>
                        <DuplicateIcon color="primary" />
                    </ListItemIcon>
                    <ListItemText
                        classes={{ primary: 'barlow_semibold_label c_bluish' }}
                        inset
                        primary={intl.formatMessage({ id: 'popup_duplicate_menuitem' })}
                    />
                </MenuItem>
                {!duplicateOnly &&
                    <MenuItem className={'bg_ice_blue'} onClick={this.props.onClick('delete')}>
                        <ListItemIcon className={'icon c_lipstick'}>
                            <TrashIcon />
                        </ListItemIcon>
                        <ListItemText
                            classes={{ primary: 'barlow_semibold_label c_lipstick' }}
                            inset
                            primary={intl.formatMessage({ id: 'popup_delete_menuitem' })}
                        />
                    </MenuItem>
                }
            </Menu>
        );
    }
}

PopupItem.propTypes = {
    intl: intlShape.isRequired,
};

const mapStateToProps = (state) => {
    return {
        info: state.info,
    };
};

export default connect(
    mapStateToProps,
    null,
)(injectIntl(PopupItem));



// WEBPACK FOOTER //
// ./src/components/complex/manage/checks/PopupItem.js